import React from 'react'
import { AccordionItem } from '../ui'
import { FeatureCheckbox } from './FeatureCheckbox'

export interface Feature {
 value: string
 label: string
}

interface FeatureGroupProps {
 title: string
 features: Feature[]
 selectedFeatures: Record<string, boolean>
 onToggle: (featureValue: string) => void
}

export const FeatureGroup: React.FC<FeatureGroupProps> = ({
 title,
 features,
 selectedFeatures,
 onToggle
}) => {
 const selectedCount = Object.values(selectedFeatures || {}).filter(Boolean).length
 const totalCount = features.length

 const titleWithCount = `${title} (${selectedCount}/${totalCount} selecionado${selectedCount !== 1 ? 's' : ''})`

 return (
 <AccordionItem title={titleWithCount}>
 <div className="grid grid-cols-1 md:grid-cols-2 gap-2">
 {features.map((feature) => (
 <FeatureCheckbox
 key={feature.value}
 label={feature.label}
 checked={selectedFeatures?.[feature.value] || false}
 onChange={() => onToggle(feature.value)}
 />
 ))}
 </div>
 </AccordionItem>
 )
}

